var about = {
	init: function(){
		$(".nav_tab li a").off().on("click", function(){
			let idx = $(".nav_tab li a").index(this);
			$(".tab").removeClass("active");
			$(".tab").eq(idx).addClass("active");
			
			$(".nav_tab li a").removeClass("active");
			$(this).addClass("active");
		});
	}
}